
<div class="box_style_2" id="main_menu">
  <h2 class="inner">Reider-Auslieferung</h2>
  <app-product-list-item
    *ngFor="let product of products"
    [product]="product">

  </app-product-list-item>
</div>
